import Service from "../Service";

const resource = "warehousetransfer/";

export default {
    list(filter, requestID) {
        return Service.post(resource + "list", filter, {
            params: { requestID: requestID },
        });
    },

    detail(filter, requestID) {
        return Service.post(resource + "detail", filter, {
            params: { requestID: requestID },
        });
    },

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },

    attend(obj, requestID) {
        return Service.post(resource + "attend", obj, {
            params: { requestID: requestID },
        });
    },

    reject(obj, requestID) {
        return Service.post(resource + "reject", obj, {
            params: { requestID: requestID },
        });
    },

    getWarehouses() {
        return Service.get(resource + "warehouses");
    },
};

